module.exports = __webpack_public_path__ + "static/media/noun_flare_tower.7f9bbfcc.png";